const getOr = require('lodash/fp/getOr');

const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const merge = require('lodash/fp/merge');

function parseOptionsPosition(position) {
  const p = path => getOr(null, path, position);

  return merge(
    parsePosition(position),
    {
      maturityDate: p('maturityDate'),
      nextFixingDate: p('nextFixingDate'),
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/options/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '7',
    positionsUrl: 'options-positions',
    transactionsUrl: 'options-transactions',
    valueMovementUrl: 'options-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseOptionsPosition,
  });

  return routeAdderFactory({ assetType: 'optionsDerivatives', service });
}

module.exports = addRoutes;

